//crie a função básica da tela
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { CommonActions, useNavigation } from "@react-navigation/native";
import Template from "../../../template/Index";
import { Box, VStack, HStack, Text, Pressable, Image } from "native-base";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useTheme } from "../../../../ThemeProvider";
import Api from "../../../../Api/Api";
import {
  FlatList,
  Image as RNImage,
  ScrollView,
  StyleSheet,
  Text as RNText,
  TouchableOpacity,
  View,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import TemplateEtapas from "../../../template/Etapas/Index";
import {
  CORES as CORES_NOVO,
  sombraCard,
} from "../../../template/Etapas/styles";
import {
  corComAlpha,
  corTextoSobre,
  gradienteCard,
} from "../../../theme/cores";
import ModalConfirmacao from "../../../../components/ModalConfirmacao";
import SkeletonAssinaturas from "../../../components/Skeleton/Assinaturas";
import StorageUtil from "../../../../Utils";
import Loader from "../../../../components/Loader";

type Plano = {
  id: number;
  nome: string;
  descricao: string;
  valor: number;
  periodicidade: string;
  popular?: boolean;
  caracteristicas: {
    descricao: string;
  }[];
};

const CORES = {
  card: "#F9F7F5",
  borda: "rgba(0,0,0,0.08)",
  caixaLista: "#E8E4DF",
  titulo: "#333333",
  secundario: "#666666",
  verde: "#5D7044",
  badge: "#C4611A",
};

function formatValorNumero(valor: number) {
  return valor.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function sufixoPeriodicidade(periodicidade: string) {
  if (!periodicidade) return "";
  const p = periodicidade.toLowerCase();
  if (p.includes("mensal")) return "/mês";
  if (p.includes("anual")) return "/ano";
  return `/${periodicidade}`;
}

/** Com profissional padrão (id 0) mostra todos; com outro, só planos vinculados a ele ou sem vínculo. */
function planoCompativelComProfissional(plano: any, profissionalId: number) {
  if (profissionalId === 0) return true;
  const profs = plano?.profissionais;
  if (!profs || !Array.isArray(profs) || profs.length === 0) return true;
  return profs.some((p: any) => Number(p?.id) === Number(profissionalId));
}

function profissionalCompletoPorId(profissionaisLista: any[], id: number) {
  return profissionaisLista.find((p) => Number(p?.id) === Number(id));
}

function formatBRL(valor: number) {
  return valor.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

type PlanoAssinaturaListItemProps = {
  plano: any;
  profissionais: any[];
  usuarioConfirmado: boolean;
  selecionarPlano: (plano: any) => void;
  setUsuarioConfirmado: (v: boolean) => void;
  navigation: any;
};

function PlanoAssinaturaListItem({
  plano,
  profissionais,
  usuarioConfirmado,
  selecionarPlano,
  setUsuarioConfirmado,
  navigation,
}: PlanoAssinaturaListItemProps) {
  return (
    <Box
      mb={5}
      borderRadius="2xl"
      bg={CORES.card}
      borderWidth={1}
      borderColor={CORES.borda}
      shadow={1}
      overflow="hidden"
    >
      {plano.popular ? (
        <Box
          bg={CORES.badge}
          alignSelf="flex-start"
          px={3}
          py={1.5}
          borderBottomRightRadius="lg"
        >
          <Text color="#FFFFFF" fontSize="xs" fontWeight="600">
            🔥 Mais popular
          </Text>
        </Box>
      ) : null}

      <VStack px={2} pt={plano.popular ? 4 : 5} pb={2} space={2}>
        <VStack space={2} alignItems="center">
          <Text
            fontSize="lg"
            fontWeight="700"
            color={CORES.titulo}
            textAlign="center"
          >
            {plano.nome}
          </Text>
          <HStack alignItems="baseline" justifyContent="center">
            <Text fontSize="sm" fontWeight="500" color={CORES.secundario}>
              R${" "}
            </Text>
            <Text fontSize="2xl" fontWeight="800" color={CORES.titulo}>
              {formatValorNumero(plano.valor)}
            </Text>
            <Text fontSize="sm" fontWeight="500" color={CORES.secundario}>
              {" "}
              {sufixoPeriodicidade(plano?.periodicidade ?? "")}
            </Text>
          </HStack>
          <Text
            fontSize="xs"
            fontWeight="400"
            color={CORES.secundario}
            marginTop={-3}
          >
            {"Validade: " + (plano?.validade ?? "")}
          </Text>
        </VStack>

        {plano?.caracteristicas?.length > 0 ? (
          <Box
            borderWidth={1}
            borderColor={CORES.caixaLista}
            borderRadius="xl"
            bg="rgba(255,255,255,0.65)"
            px={3}
            py={3}
          >
            <VStack space={2}>
              {plano?.caracteristicas?.map((item: any, idx: number) => (
                <HStack key={idx} space={1} alignItems="center">
                  <Box
                    w={4}
                    h={4}
                    borderRadius="full"
                    bg={CORES.verde}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <MaterialCommunityIcons
                      name="check"
                      size={12}
                      color="#FFFFFF"
                    />
                  </Box>
                  <Text
                    flex={1}
                    fontSize="sm"
                    fontWeight="600"
                    color={CORES.titulo}
                  >
                    {item.descricao}
                  </Text>
                </HStack>
              ))}
            </VStack>
          </Box>
        ) : null}

        <Box h="1px" bg="#D9D5D0" w="100%" />

        {(plano.profissionais?.length ?? 0) === 1 ? (
          <HStack space={2} alignItems="center">
            <Image
              source={
                profissionais.find((p) => p.id === plano.profissionais[0].id)
                  ?.foto == null
                  ? require("../../../img/avatar-pessoa.jpg")
                  : {
                      uri: profissionais.find(
                        (p) => p.id === plano.profissionais[0].id,
                      )?.foto?.url,
                    }
              }
              alt="Avatar"
              resizeMode="cover"
              height={10}
              width={10}
              borderRadius={100}
              borderWidth={1}
              borderColor={CORES.borda}
            />
            <VStack>
              <Text fontSize="sm" fontWeight="500" color={CORES.titulo}>
                {plano.profissionais[0].nome}
              </Text>
              <Text fontSize="xs" fontWeight="400" color={CORES.secundario}>
                Atendente
              </Text>
            </VStack>
          </HStack>
        ) : (
          <VStack>
            <Text fontSize="sm" fontWeight="500" color={CORES.titulo}>
              {"Atendente"}
            </Text>
            <Text fontSize="xs" fontWeight="400" color={CORES.secundario}>
              Você pode escolher o atendente
            </Text>
          </VStack>
        )}

        <Box h="1px" bg="#D9D5D0" w="100%" />

        <Text
          fontSize="xs"
          fontWeight="400"
          color={CORES.secundario}
          textAlign="center"
          lineHeight={18}
          px={1}
        >
          {plano?.descricao ?? ""}
        </Text>

        <Pressable
          onPress={() => {
            if (usuarioConfirmado) {
              selecionarPlano(plano);
              return;
            }
            navigation.navigate("DadosUsuario", {
              dadosAssinatura: plano,
              onVoltar: (newPlano: any) => {
                setUsuarioConfirmado(true);
                selecionarPlano(newPlano);
              },
            });
          }}
          bg={CORES.verde}
          py={3.5}
          borderRadius="full"
          alignItems="center"
          justifyContent="center"
          _pressed={{ opacity: 0.9 }}
        >
          <Text color="#FFFFFF" fontWeight="700" fontSize="md">
            Assinar plano
          </Text>
        </Pressable>
      </VStack>
    </Box>
  );
}

// ---------------- Card do layout novo ----------------

const DOURADO = "#E3BF7A";

function primeiraMaiuscula(texto: string) {
  if (!texto) return "";
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
}

function textoPeriodicidade(periodicidade: string) {
  if (!periodicidade) return "";
  const p = periodicidade.toLowerCase();
  if (p.includes("semestral")) return "por semestre";
  if (p.includes("trimestral")) return "por trimestre";
  if (p.includes("bimestral")) return "por bimestre";
  if (p.includes("quinzenal")) return "por quinzena";
  if (p.includes("semanal")) return "por semana";
  if (p.includes("mensal")) return "por mês";
  if (p.includes("anual")) return "por ano";
  if (p.includes("diari") || p.includes("diári")) return "por dia";
  return p;
}

type PlanoCardNovoProps = {
  plano: any;
  profissionais: any[];
  corPrincipal: string;
  onAssinar: () => void;
};

function PlanoCardNovo({
  plano,
  profissionais,
  corPrincipal,
  onAssinar,
}: PlanoCardNovoProps) {
  const destaque = !!plano.popular;
  const corTexto = destaque ? corTextoSobre(corPrincipal) : CORES_NOVO.titulo;
  const corSecundaria = destaque ? corTexto : CORES_NOVO.subtitulo;

  const [reais, centavos] = formatValorNumero(Number(plano.valor || 0)).split(
    ",",
  );

  const profissionalUnico =
    (plano.profissionais?.length ?? 0) === 1
      ? profissionalCompletoPorId(profissionais, plano.profissionais[0].id) ??
        plano.profissionais[0]
      : null;

  const conteudo = (
    <View style={stylesNovo.conteudoPlano}>
      {destaque && (
        <View style={stylesNovo.badgePopular}>
          <Feather name="star" size={11} color={DOURADO} />
          <RNText style={stylesNovo.textoBadgePopular}>MAIS POPULAR</RNText>
        </View>
      )}

      <View style={stylesNovo.topoPlano}>
        <View style={{ flex: 1 }}>
          <RNText style={[stylesNovo.nomePlano, { color: corTexto }]}>
            {plano.nome}
          </RNText>
          {!!plano.validade && (
            <RNText
              style={[
                stylesNovo.validadePlano,
                { color: corSecundaria },
                destaque && { opacity: 0.8 },
              ]}
            >
              Válido por {String(plano.validade)}
            </RNText>
          )}
        </View>

        <View style={{ alignItems: "flex-end" }}>
          <View style={stylesNovo.linhaPreco}>
            <RNText style={[stylesNovo.moeda, { color: corTexto }]}>R$</RNText>
            <RNText style={[stylesNovo.precoInteiro, { color: corTexto }]}>
              {reais}
            </RNText>
            <RNText style={[stylesNovo.precoCentavos, { color: corTexto }]}>
              ,{centavos}
            </RNText>
          </View>
          <RNText
            style={[
              stylesNovo.periodicidade,
              { color: corSecundaria },
              destaque && { opacity: 0.8 },
            ]}
          >
            {textoPeriodicidade(plano.periodicidade ?? "")}
          </RNText>
        </View>
      </View>

      {plano?.caracteristicas?.length > 0 && (
        <View style={stylesNovo.caracteristicas}>
          {plano.caracteristicas.map((item: any, idx: number) => (
            <View key={idx} style={stylesNovo.linhaCaracteristica}>
              <Feather
                name="check"
                size={14}
                color={destaque ? DOURADO : corPrincipal}
              />
              <RNText
                style={[stylesNovo.textoCaracteristica, { color: corTexto }]}
              >
                {item.descricao}
              </RNText>
            </View>
          ))}
        </View>
      )}

      <View
        style={[
          stylesNovo.divisor,
          destaque && { backgroundColor: "rgba(255,255,255,0.15)" },
        ]}
      />

      <View style={stylesNovo.linhaProfissional}>
        {profissionalUnico ? (
          <>
            {profissionalUnico.foto?.url ? (
              <RNImage
                source={{ uri: profissionalUnico.foto.url }}
                style={stylesNovo.fotoProfissional}
              />
            ) : (
              <View
                style={[
                  stylesNovo.fotoProfissional,
                  { backgroundColor: corComAlpha(corPrincipal, 0.12) },
                ]}
              >
                <RNText style={{ color: corPrincipal, fontWeight: "800" }}>
                  {String(profissionalUnico.nome || "?").charAt(0)}
                </RNText>
              </View>
            )}
            <RNText style={[stylesNovo.textoProfissional, { color: corSecundaria }]}>
              Com{" "}
              <RNText style={{ fontWeight: "700", color: corTexto }}>
                {profissionalUnico.nome}
              </RNText>
            </RNText>
          </>
        ) : (
          <>
            <View
              style={[
                stylesNovo.fotoProfissional,
                {
                  backgroundColor: destaque
                    ? "rgba(255,255,255,0.12)"
                    : corComAlpha(corPrincipal, 0.1),
                },
              ]}
            >
              <Feather
                name="users"
                size={15}
                color={destaque ? DOURADO : corPrincipal}
              />
            </View>
            <RNText
              style={[
                stylesNovo.textoProfissional,
                { color: corTexto, fontWeight: "700" },
              ]}
            >
              Qualquer profissional
            </RNText>
          </>
        )}
      </View>

      {!!plano?.descricao && (
        <RNText
          style={[
            stylesNovo.descricaoPlano,
            { color: corSecundaria },
            destaque && { opacity: 0.8 },
          ]}
        >
          {plano.descricao}
        </RNText>
      )}

      <TouchableOpacity
        activeOpacity={0.85}
        onPress={onAssinar}
        style={[
          stylesNovo.botaoAssinar,
          { backgroundColor: destaque ? "#fff" : corPrincipal },
        ]}
      >
        <RNText
          style={[
            stylesNovo.textoAssinar,
            { color: destaque ? corPrincipal : corTextoSobre(corPrincipal) },
          ]}
        >
          Assinar plano
        </RNText>
      </TouchableOpacity>
    </View>
  );

  if (destaque) {
    return (
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          borderRadius: 20,
          marginBottom: 14,
          backgroundColor: corPrincipal,
          backgroundImage: gradienteCard(corPrincipal),
          boxShadow: "0 10px 24px rgba(0,0,0,0.16)",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 160,
            height: 160,
            top: -50,
            right: -40,
            borderRadius: "50%",
            border: "1px solid rgba(255,255,255,0.12)",
            pointerEvents: "none",
          }}
        />
        {conteudo}
      </div>
    );
  }

  return <View style={[stylesNovo.cardPlano, sombraCard]}>{conteudo}</View>;
}

const Assinaturas: React.FC = () => {
  const navigation = useNavigation<any>();
  const refModal = useRef<any>(null);
  const [profissionais, setProfissionais] = useState<any[]>([]);
  const { getCodEmpresa, isMobile, configEmpresa, primaryColor } = useTheme();
  const [planos, setPlanos] = useState<any[]>([]);
  const [profissionalSelecionadoFiltro, setProfissionalSelecionadoFiltro] =
    useState<any>({
      id: 0,
      nome: "Todos",
      foto: null,
      atendente: true,
    });
  const [planoSelecionado, setPlanoSelecionado] = useState<any>({});
  const [profissionalEscolhido, setProfissionalEscolhido] = useState<any>(null);
  const [pacoteEscolhido, setPacoteEscolhido] = useState<any>(null);
  const [usuarioConfirmado, setUsuarioConfirmado] = useState<boolean>(false);
  const [formaPagamentoEscolhida, setFormaPagamentoEscolhida] =
    useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [fotosComErro, setFotosComErro] = useState<any[]>([]);

  const modalSelecionarProfissionalRef = useRef<any>(null);
  const pacotesModalRef = useRef<any>(null);
  const formasPagamentoModalRef = useRef<any>(null);
  const resumoConfirmacaoRef = useRef<any>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;
    (async () => {
      setCarregando(true);
      try {
        await Promise.all([getProfissionais(), getPlanos()]);
      } finally {
        if (ativo) setCarregando(false);
      }
    })();
    return () => {
      ativo = false;
    };
  }, []);

  async function getProfissionais() {
    const profissionais = await Api.profissionais(Number(getCodEmpresa));
    if (profissionais.status) {
      profissionais.data.unshift({
        id: 0,
        nome: "Todos",
        foto: null,
        atendente: true,
      });
      setProfissionais(profissionais.data);
    } else {
      console.log("erro ao buscar profissionais ", profissionais.error_message);
      refModal.current.abrirModal("Erro ao buscar profissionais");
    }
  }
  async function getPlanos() {
    const planos = await Api.planosAssinatura(Number(getCodEmpresa));
    if (planos.status) {
      setPlanos(planos.data);
    } else {
      console.log("erro ao buscar planos ", planos.error_message);
    }
  }

  const planosFiltrados = useMemo(() => {
    const id = Number(profissionalSelecionadoFiltro?.id ?? 0);
    return planos.filter((plano) => planoCompativelComProfissional(plano, id));
  }, [planos, profissionalSelecionadoFiltro]);

  /** Modal de atendentes: vínculos do plano; se vazio, lista geral (sem "Todos", id 0). */
  const profissionaisParaModalSelecao = useMemo(() => {
    const doPlano = planoSelecionado?.profissionais;

    if (Array.isArray(doPlano) && doPlano.length > 0) {
      return doPlano;
    }

    return profissionais.filter((p) => Number(p?.id) !== 0);
  }, [planoSelecionado?.profissionais, profissionais]);

  const confirmarProfissionalSelecionado = (refProf: any, plano: any) => {
    const dados = profissionalCompletoPorId(profissionais, refProf.id);
    setProfissionalEscolhido(
      dados ?? {
        id: refProf.id,
        nome: refProf.nome ?? "",
        foto: null,
      },
    );
    modalSelecionarProfissionalRef.current?.fecharModal();
    if (plano.pacotes && plano.pacotes.length === 1) {
      confirmarPacoteSelecionado(plano.pacotes[0], plano);
      return;
    }

    setPacoteEscolhido(null);
    if (plano?.pacotes && plano.pacotes.length > 0) {
      pacotesModalRef.current?.abrirModal();
    }
  };

  const confirmarPacoteSelecionado = (pacote: any, plano: any) => {
    setPacoteEscolhido(pacote);
    pacotesModalRef.current?.fecharModal();
    setFormaPagamentoEscolhida(null);
    const formas = plano?.formasPagamento;
    if (formas && Array.isArray(formas) && formas.length > 0) {
      formasPagamentoModalRef.current?.abrirModal();
      return;
    }
    //modal com mensagem de erro
    refModal.current.abrirModal("Erro ao confirmar pacote", "error");
  };

  const confirmarFormaPagamentoSelecionada = (forma: any) => {
    setFormaPagamentoEscolhida(forma);
    formasPagamentoModalRef.current?.fecharModal();
    resumoConfirmacaoRef.current?.abrirModal();
  };

  const confirmarContratacao = async () => {
    // resumoConfirmacaoRef.current?.fecharModal();
    // const resposta = await Api.planosAssinaturaContratar({
    //   profissionalEscolhido,
    //   pacoteEscolhido,
    //   formaPagamentoEscolhida,
    //   planoSelecionado,
    // });
    // if (resposta.status) {
    //   console.log("resposta ", resposta.data);
    // } else {
    //   console.log("erro ao confirmar contratacao ", resposta.error_message);
    // }
    setLoading(true);
    const cliente = await StorageUtil.getItem("cliente");

    if (!cliente || !cliente.id) {
      refModal.current.abrirModal("Erro ao confirmar contratacao", "error");
      setLoading(false);
      return;
    }

    const data = {
      idPlano: planoSelecionado.id,
      idPacote: pacoteEscolhido.id,
      idProfissional: profissionalEscolhido.id,
      formaPagamento: formaPagamentoEscolhida.id,
      clienteId: cliente?.id ?? 0,
      codEmpresa: getCodEmpresa,
    };

    const resposta = await Api.planosAssinaturaContratar(data);

    setLoading(false);
    if (!resposta.status) {
      refModal.current.abrirModal(
        resposta.error_details?.message ?? "Erro ao confirmar contratacao",
        "error",
      );
      return;
    }

    window.history.pushState(
      {},
      "",
      "/preencher-link-pagamento?hash=" +
        resposta.data?.hash +
        "&cdTrsOpr=" +
        resposta.data?.codigoTransacao,
    );

    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "TabNavigator", params: { screen: "Inicio" } }],
      }),
    );

    // console.log("Para enviar para a API: ", data);
  };

  const selecionarPlano = (plano: any) => {
    setPlanoSelecionado(plano);
    setFormaPagamentoEscolhida(null);
    if (plano.profissionais.length === 1) {
      confirmarProfissionalSelecionado(plano.profissionais[0], plano);
      return;
    }
    modalSelecionarProfissionalRef.current?.abrirModal();
  };

  const listaProfissionaisHeader = useMemo(
    () => (
      <Box mb={5}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "center",
            paddingHorizontal: 4,
          }}
        >
          <HStack space={2} alignItems="center">
            {profissionais.map((profissional) => (
              <TouchableOpacity
                key={profissional.id}
                onPress={() => setProfissionalSelecionadoFiltro(profissional)}
              >
                <VStack alignItems="center" w={16}>
                  <Image
                    source={
                      profissional.foto == null
                        ? require("../../../img/avatar-pessoa.jpg")
                        : {
                            uri: profissional.foto?.url,
                          }
                    }
                    alt="Avatar"
                    resizeMode="cover"
                    height={16}
                    width={16}
                    borderRadius={100}
                    borderWidth={
                      profissionalSelecionadoFiltro?.id === profissional.id
                        ? 3
                        : 1
                    }
                    borderColor={
                      profissionalSelecionadoFiltro?.id === profissional.id
                        ? CORES.verde
                        : CORES.borda
                    }
                  />
                  <VStack>
                    <Text
                      fontSize="sm"
                      fontWeight="500"
                      color={CORES.titulo}
                      textAlign="center"
                      numberOfLines={1}
                    >
                      {profissional.nome.split(" ")[0]}
                    </Text>
                  </VStack>
                </VStack>
              </TouchableOpacity>
            ))}
          </HStack>
        </ScrollView>
      </Box>
    ),
    [profissionais, profissionalSelecionadoFiltro],
  );

  const renderPlanoItem = useCallback(
    ({ item }: { item: any }) => (
      <PlanoAssinaturaListItem
        plano={item}
        profissionais={profissionais}
        usuarioConfirmado={usuarioConfirmado}
        selecionarPlano={selecionarPlano}
        setUsuarioConfirmado={setUsuarioConfirmado}
        navigation={navigation}
      />
    ),
    [
      profissionais,
      usuarioConfirmado,
      selecionarPlano,
      navigation,
      setUsuarioConfirmado,
    ],
  );

  const listEmptyPlanos = useCallback(
    () => (
      <VStack space={2} alignItems="center" mt={2}>
        <Box h="1px" bg="#D9D5D0" w="100%" opacity={0.85} />
        <Text fontSize="sm" color={CORES.secundario} textAlign="center">
          Nenhum plano disponível no momento.
        </Text>
      </VStack>
    ),
    [],
  );

  function renderModais() {
    return (
      <>
        <ModalConfirmacao
          ref={modalSelecionarProfissionalRef}
          titulo={"Atenção"}
          mensagem={
            "Os atendentes disponíveis para este plano estão listados abaixo, CLIQUE para selecionar"
          }
          textoBotaoNegativo={"Cancelar"}
          textoBotaoPositivo={"Confirmar"}
          semBotoes={true}
        >
          <Box w="100%" mt={2}>
            {profissionaisParaModalSelecao.length === 0 && (
              <Text fontSize="sm" color={CORES.secundario} textAlign="center">
                Nenhum atendente disponível para seleção.
              </Text>
            )}
            {profissionaisParaModalSelecao.length > 0 && (
              <VStack space={0} w="100%">
                {profissionaisParaModalSelecao.map(
                  (refProf: any, index: number) => {
                    const dados = profissionalCompletoPorId(
                      profissionais,
                      refProf.id,
                    );
                    const nomeExibir = dados?.nome ?? refProf.nome ?? "";
                    const temFoto = dados?.foto != null && dados?.foto?.url;
                    const lista = profissionaisParaModalSelecao;
                    const isUltimo = index === lista.length - 1;
                    return (
                      <VStack key={refProf.id} w="100%">
                        <TouchableOpacity
                          activeOpacity={0.65}
                          onPress={() => {
                            confirmarProfissionalSelecionado(
                              refProf,
                              planoSelecionado,
                            );
                          }}
                        >
                          <HStack space={3} alignItems="center" py={2.5}>
                            <Image
                              source={
                                temFoto
                                  ? { uri: dados.foto.url }
                                  : require("../../../img/avatar-pessoa.jpg")
                              }
                              alt="Avatar"
                              resizeMode="cover"
                              height={12}
                              width={12}
                              borderRadius={999}
                              borderWidth={1}
                              borderColor={CORES.borda}
                            />

                            <VStack flex={1}>
                              <Text
                                fontSize="sm"
                                fontWeight="600"
                                color={CORES.titulo}
                              >
                                {nomeExibir}
                              </Text>
                              <Text fontSize="xs" color={CORES.secundario}>
                                Atendente
                              </Text>
                            </VStack>
                          </HStack>
                        </TouchableOpacity>
                        {!isUltimo ? (
                          <Box h="1px" bg="#D9D5D0" w="100%" opacity={0.85} />
                        ) : null}
                      </VStack>
                    );
                  },
                )}
              </VStack>
            )}
          </Box>
        </ModalConfirmacao>

        <ModalConfirmacao
          ref={pacotesModalRef}
          titulo={"Pacotes"}
          mensagem={
            "Os pacotes deste plano estão listados abaixo. Toque para selecionar."
          }
          semBotoes={true}
        >
          <Box w="100%" mt={2}>
            {(!planoSelecionado?.pacotes ||
              planoSelecionado.pacotes.length === 0) && (
              <Text fontSize="sm" color={CORES.secundario} textAlign="center">
                Nenhum pacote vinculado a este plano.
              </Text>
            )}
            {planoSelecionado?.pacotes?.length > 0 && (
              <VStack space={0} w="100%">
                {planoSelecionado.pacotes.map((pacote: any, index: number) => {
                  const lista = planoSelecionado.pacotes;
                  const isUltimo = index === lista.length - 1;
                  const chave =
                    pacote?.id != null ? String(pacote.id) : `pacote-${index}`;
                  return (
                    <VStack key={chave} w="100%">
                      <TouchableOpacity
                        activeOpacity={0.65}
                        onPress={() =>
                          confirmarPacoteSelecionado(pacote, planoSelecionado)
                        }
                      >
                        <Box py={3} px={2}>
                          <Text
                            fontSize="sm"
                            fontWeight="500"
                            color={CORES.titulo}
                          >
                            {pacote?.descricao ?? ""}
                          </Text>
                        </Box>
                      </TouchableOpacity>
                      {!isUltimo ? (
                        <Box h="1px" bg="#D9D5D0" w="100%" opacity={0.85} />
                      ) : null}
                    </VStack>
                  );
                })}
              </VStack>
            )}
          </Box>
        </ModalConfirmacao>

        <ModalConfirmacao
          ref={formasPagamentoModalRef}
          titulo={"Forma de pagamento"}
          mensagem={
            "Escolha como deseja pagar esta assinatura. Toque para selecionar."
          }
          semBotoes={true}
        >
          <Box w="100%" mt={2}>
            {(!planoSelecionado?.formasPagamento ||
              planoSelecionado.formasPagamento.length === 0) && (
              <Text fontSize="sm" color={CORES.secundario} textAlign="center">
                Nenhuma forma de pagamento configurada para este plano.
              </Text>
            )}
            {planoSelecionado?.formasPagamento?.length > 0 && (
              <VStack space={0} w="100%">
                {planoSelecionado.formasPagamento.map(
                  (forma: any, index: number) => {
                    const lista = planoSelecionado.formasPagamento;
                    const isUltimo = index === lista.length - 1;
                    const chave =
                      forma?.id != null ? String(forma.id) : `forma-${index}`;
                    return (
                      <VStack key={chave} w="100%">
                        <TouchableOpacity
                          activeOpacity={0.65}
                          onPress={() =>
                            confirmarFormaPagamentoSelecionada(forma)
                          }
                        >
                          <HStack space={3} alignItems="center" py={3} px={2}>
                            <MaterialCommunityIcons
                              name="credit-card-outline"
                              size={22}
                              color={CORES.verde}
                            />
                            <Text
                              fontSize="sm"
                              fontWeight="500"
                              color={CORES.titulo}
                              flex={1}
                            >
                              {forma?.nome ?? "—"}
                            </Text>
                          </HStack>
                        </TouchableOpacity>
                        {!isUltimo ? (
                          <Box h="1px" bg="#D9D5D0" w="100%" opacity={0.85} />
                        ) : null}
                      </VStack>
                    );
                  },
                )}
              </VStack>
            )}
          </Box>
        </ModalConfirmacao>

        <ModalConfirmacao
          ref={resumoConfirmacaoRef}
          titulo={"Confirmar assinatura"}
          mensagem={
            "Confira se os dados estão corretos antes de seguir com a assinatura."
          }
          textoBotaoNegativo={"Cancelar"}
          textoBotaoPositivo={"Confirmar"}
          onConfirmNegativo={() => {
            resumoConfirmacaoRef.current?.fecharModal();
          }}
          onConfirmPositivo={() => {
            confirmarContratacao();
          }}
        >
          <Box w="100%" mt={3}>
            <VStack
              space={0}
              borderWidth={1}
              borderColor={CORES.caixaLista}
              borderRadius="lg"
              bg="rgba(255,255,255,0.7)"
              px={3}
              py={2}
            >
              <VStack py={2} space={1}>
                <Text fontSize="xs" color={CORES.secundario} fontWeight="500">
                  Plano
                </Text>
                <Text fontSize="md" fontWeight="700" color={CORES.titulo}>
                  {planoSelecionado?.nome ?? "—"}
                </Text>
              </VStack>

              <Box h="1px" bg="#D9D5D0" w="100%" />

              <VStack py={2} space={1}>
                <Text fontSize="xs" color={CORES.secundario} fontWeight="500">
                  Valor
                </Text>
                <Text fontSize="md" fontWeight="700" color={CORES.titulo}>
                  {(() => {
                    const suf = sufixoPeriodicidade(
                      planoSelecionado?.periodicidade ?? "",
                    );
                    if (planoSelecionado?.valor == null) return "—";
                    return `${formatBRL(planoSelecionado.valor)}${
                      suf ? ` ${suf}` : ""
                    }`;
                  })()}
                </Text>
              </VStack>

              {planoSelecionado?.validade ? (
                <>
                  <Box h="1px" bg="#D9D5D0" w="100%" />
                  <VStack py={2} space={1}>
                    <Text fontSize="xs" color={CORES.secundario} fontWeight="500">
                      Validade do plano
                    </Text>
                    <Text fontSize="sm" fontWeight="600" color={CORES.titulo}>
                      {String(planoSelecionado.validade)}
                    </Text>
                  </VStack>
                </>
              ) : null}

              <Box h="1px" bg="#D9D5D0" w="100%" />

              <VStack py={2} space={2}>
                <Text fontSize="xs" color={CORES.secundario} fontWeight="500">
                  Atendente
                </Text>
                {profissionalEscolhido ? (
                  <HStack space={3} alignItems="center">
                    <Image
                      source={
                        profissionalEscolhido?.foto?.url
                          ? { uri: profissionalEscolhido.foto.url }
                          : require("../../../img/avatar-pessoa.jpg")
                      }
                      alt="Avatar"
                      resizeMode="cover"
                      height={10}
                      width={10}
                      borderRadius={999}
                      borderWidth={1}
                      borderColor={CORES.borda}
                    />
                    <Text
                      fontSize="sm"
                      fontWeight="600"
                      color={CORES.titulo}
                      flex={1}
                    >
                      {profissionalEscolhido.nome ?? "—"}
                    </Text>
                  </HStack>
                ) : (
                  <Text fontSize="sm" color={CORES.secundario}>
                    —
                  </Text>
                )}
              </VStack>

              <Box h="1px" bg="#D9D5D0" w="100%" />

              {planoSelecionado?.pacotes?.length > 1 && (
                <VStack py={2} space={1}>
                  <Text fontSize="xs" color={CORES.secundario} fontWeight="500">
                    Pacote
                  </Text>
                  <Text fontSize="sm" fontWeight="600" color={CORES.titulo}>
                    {pacoteEscolhido?.descricao ?? "—"}
                  </Text>
                </VStack>
              )}

              {planoSelecionado?.pacotes?.length > 1 && (
                <Box h="1px" bg="#D9D5D0" w="100%" />
              )}

              <VStack py={2} space={1}>
                <Text fontSize="xs" color={CORES.secundario} fontWeight="500">
                  Forma de pagamento
                </Text>
                <Text fontSize="sm" fontWeight="600" color={CORES.titulo}>
                  {formaPagamentoEscolhida?.nome ?? "—"}
                </Text>
              </VStack>

              {planoSelecionado?.descricao ? (
                <>
                  <Box h="1px" bg="#D9D5D0" w="100%" />
                  <VStack py={2} space={1}>
                    <Text fontSize="xs" color={CORES.secundario} fontWeight="500">
                      Observações
                    </Text>
                    <Text fontSize="xs" color={CORES.secundario} lineHeight={18}>
                      {planoSelecionado.descricao}
                    </Text>
                  </VStack>
                </>
              ) : null}
            </VStack>
          </Box>
        </ModalConfirmacao>
      </>
    );
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const config = (() => {
    try {
      return typeof configEmpresa === "string"
        ? JSON.parse(configEmpresa)
        : configEmpresa || {};
    } catch (error) {
      return {};
    }
  })();

  const utilizaLayoutLegado =
    config.utilizaPwaSimples ||
    config.versaoPWA == 2 ||
    config.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";

  function assinarPlano(plano: any) {
    if (usuarioConfirmado) {
      selecionarPlano(plano);
      return;
    }
    navigation.navigate("DadosUsuario", {
      dadosAssinatura: plano,
      onVoltar: (newPlano: any) => {
        setUsuarioConfirmado(true);
        selecionarPlano(newPlano);
      },
    });
  }

  function voltarInicio() {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "TabNavigator", params: { screen: "Inicio" } }],
      }),
    );
  }

  function renderFiltroProfissionaisNovo() {
    return (
      <View>
        <RNText style={stylesNovo.rotuloSecao}>FILTRAR POR PROFISSIONAL</RNText>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ gap: 14, paddingVertical: 2 }}
        >
          {profissionais.map((profissional) => {
            const selecionado =
              profissionalSelecionadoFiltro?.id === profissional.id;
            const todos = Number(profissional.id) === 0;

            return (
              <TouchableOpacity
                key={profissional.id}
                style={stylesNovo.itemFiltro}
                onPress={() => setProfissionalSelecionadoFiltro(profissional)}
              >
                <View
                  style={[
                    stylesNovo.anelFiltro,
                    selecionado && { borderColor: corPrincipal },
                  ]}
                >
                  {todos ? (
                    <View
                      style={[
                        stylesNovo.avatarFiltro,
                        { backgroundColor: corPrincipal },
                      ]}
                    >
                      <RNText
                        style={[
                          stylesNovo.textoTodos,
                          { color: corTextoSobre(corPrincipal) },
                        ]}
                      >
                        Todos
                      </RNText>
                    </View>
                  ) : profissional.foto?.url &&
                    !fotosComErro.includes(profissional.id) ? (
                    <RNImage
                      source={{ uri: profissional.foto.url }}
                      style={stylesNovo.avatarFiltro}
                      resizeMode="cover"
                      onError={() =>
                        setFotosComErro((atual) => [...atual, profissional.id])
                      }
                    />
                  ) : (
                    <View
                      style={[
                        stylesNovo.avatarFiltro,
                        stylesNovo.avatarSemFoto,
                      ]}
                    >
                      <RNText style={stylesNovo.inicialFiltro}>
                        {String(profissional.nome || "?")
                          .trim()
                          .charAt(0)
                          .toUpperCase()}
                      </RNText>
                    </View>
                  )}
                </View>
                <RNText
                  style={[
                    stylesNovo.nomeFiltro,
                    selecionado && { color: corPrincipal, fontWeight: "700" },
                  ]}
                  numberOfLines={1}
                >
                  {primeiraMaiuscula(
                    String(profissional.nome || "").split(" ")[0],
                  )}
                </RNText>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </View>
    );
  }

  if (!utilizaLayoutLegado) {
    return (
      <TemplateEtapas
        ref={refModal}
        rotuloEtapa="Assinaturas"
        titulo="Planos de assinatura"
        subtitulo="Escolha um plano e economize nas visitas."
        filtro={carregando ? undefined : renderFiltroProfissionaisNovo()}
        ocultarFechar
        ocultarRodape
        onVoltarClick={voltarInicio}
      >
        {carregando ? (
          <SkeletonAssinaturas />
        ) : planosFiltrados.length === 0 ? (
          <View style={stylesNovo.vazio}>
            <Feather name="award" size={40} color={CORES_NOVO.subtitulo} />
            <RNText style={stylesNovo.textoVazio}>
              Nenhum plano disponível no momento.
            </RNText>
          </View>
        ) : (
          planosFiltrados.map((plano, index) => (
            <PlanoCardNovo
              key={plano?.id != null ? String(plano.id) : `plano-${index}`}
              plano={plano}
              profissionais={profissionais}
              corPrincipal={corPrincipal}
              onAssinar={() => assinarPlano(plano)}
            />
          ))
        )}

        {loading && <Loader texto="Aguarde..." />}
        {renderModais()}
      </TemplateEtapas>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={"Assinaturas"}
      messageAlerta="Selecione o atendente e verifique os planos disponíveis"
      onBotaoVoltarClick={() => {
        navigation.dispatch(
          CommonActions.reset({
            index: 0,
            routes: [{ name: "TabNavigator", params: { screen: "Inicio" } }],
          }),
        );
      }}
      escondeBotoesRodape={true}
      ref={refModal}
    >
      <VStack space={5} w="80%" pb={6} px={1}>
        {carregando ? (
          <SkeletonAssinaturas />
        ) : (
          <FlatList
            data={planosFiltrados}
            keyExtractor={(item, index) =>
              item?.id != null ? String(item.id) : `plano-${index}`
            }
            renderItem={renderPlanoItem}
            ListHeaderComponent={listaProfissionaisHeader}
            ListEmptyComponent={listEmptyPlanos}
            showsVerticalScrollIndicator={false}
            nestedScrollEnabled
            keyboardShouldPersistTaps="handled"
            contentContainerStyle={{ paddingBottom: 8 }}
          />
        )}
      </VStack>

      {loading && <Loader texto="Aguarde..." />}

      {renderModais()}
    </Template>
  );
};

const stylesNovo = StyleSheet.create({
  rotuloSecao: {
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1.5,
    color: CORES_NOVO.subtitulo,
    marginBottom: 10,
  },
  itemFiltro: {
    alignItems: "center",
    width: 62,
  },
  anelFiltro: {
    width: 60,
    height: 60,
    borderRadius: 30,
    padding: 3,
    borderWidth: 2,
    borderColor: "transparent",
  },
  avatarFiltro: {
    width: "100%",
    height: "100%",
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  textoTodos: {
    fontSize: 12,
    fontWeight: "800",
  },
  avatarSemFoto: {
    backgroundColor: "#EFE9DF",
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.08)",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 6,
  },
  inicialFiltro: {
    fontSize: 20,
    fontWeight: "800",
    color: "#8a7f6c",
  },
  nomeFiltro: {
    fontSize: 12,
    color: CORES_NOVO.subtitulo,
    marginTop: 4,
  },
  cardPlano: {
    marginBottom: 14,
    borderRadius: 20,
    backgroundColor: CORES_NOVO.card,
    borderWidth: 1,
    borderColor: CORES_NOVO.borda,
  },
  conteudoPlano: {
    padding: 18,
  },
  badgePopular: {
    alignSelf: "flex-start",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 12,
    backgroundColor: "rgba(255,255,255,0.12)",
    marginBottom: 12,
  },
  textoBadgePopular: {
    color: DOURADO,
    fontSize: 10,
    fontWeight: "800",
    letterSpacing: 1.2,
  },
  topoPlano: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
  },
  nomePlano: {
    fontSize: 19,
    fontWeight: "800",
  },
  validadePlano: {
    fontSize: 12,
    marginTop: 3,
  },
  linhaPreco: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  moeda: {
    fontSize: 12,
    fontWeight: "700",
    marginTop: 8,
    marginRight: 2,
  },
  precoInteiro: {
    fontSize: 30,
    lineHeight: 34,
    fontWeight: "800",
  },
  precoCentavos: {
    fontSize: 14,
    fontWeight: "800",
    marginTop: 4,
  },
  periodicidade: {
    fontSize: 11,
  },
  caracteristicas: {
    marginTop: 14,
    gap: 6,
  },
  linhaCaracteristica: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  textoCaracteristica: {
    flex: 1,
    fontSize: 13,
    fontWeight: "600",
  },
  divisor: {
    height: 1,
    backgroundColor: CORES_NOVO.borda,
    marginVertical: 14,
  },
  linhaProfissional: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  fotoProfissional: {
    width: 30,
    height: 30,
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  textoProfissional: {
    flex: 1,
    fontSize: 13,
  },
  descricaoPlano: {
    fontSize: 12,
    lineHeight: 17,
    marginTop: 12,
  },
  botaoAssinar: {
    height: 48,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 16,
  },
  textoAssinar: {
    fontSize: 15,
    fontWeight: "700",
  },
  vazio: {
    alignItems: "center",
    paddingVertical: 40,
    gap: 12,
  },
  textoVazio: {
    fontSize: 15,
    color: CORES_NOVO.subtitulo,
    textAlign: "center",
  },
});

export default Assinaturas;
